import { useMemo } from "react";

type Props = {
  activeDays: string[];
  days?: number;
};

const UserSparkline = ({ activeDays, days = 30 }: Props) => {
  const cells = useMemo(() => {
    const set = new Set(activeDays);
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0);
    const out: { day: string; active: boolean }[] = [];
    for (let i = days - 1; i >= 0; i--) {
      const d = new Date(today);
      d.setUTCDate(today.getUTCDate() - i);
      const key = d.toISOString().slice(0, 10);
      out.push({ day: key, active: set.has(key) });
    }
    return out;
  }, [activeDays, days]);

  const activeCount = cells.filter((c) => c.active).length;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-end gap-[2px]" title={`${activeCount}/${days} active days`}>
        {cells.map((c) => (
          <div
            key={c.day}
            className={`h-4 w-1 rounded-sm ${c.active ? "bg-primary" : "bg-muted"}`}
            title={`${c.day}${c.active ? " — active" : ""}`}
          />
        ))}
      </div>
      <span className="text-muted-foreground text-[10px]">
        {activeCount}/{days}j
      </span>
    </div>
  );
};

export default UserSparkline;
